module.exports = __webpack_public_path__ + "static/media/end-assess-bkg.f7e401e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/end-assess-bkg.png
// module id = 781
// module chunks = 0